module.exports = __webpack_public_path__ + "files/4f2731a31e3389338e2239887674e975.svg";